import { apiRequestGet } from 'mastodon/api';
import type {
  ApiTermsOfServiceJSON,
  ApiPrivacyPolicyJSON,
  ApiInstanceJSON,
  ApiExtendedDescriptionJSON,
  ApiTranslationLanguagesJSON,
  ApiDomainBlockJSON,
} from 'mastodon/api_types/instance';

export const apiGetTermsOfService = (version?: string) =>
  apiRequestGet<ApiTermsOfServiceJSON>(
    version
      ? `v1/instance/terms_of_service/${version}`
      : 'v1/instance/terms_of_service',
  );

export const apiGetPrivacyPolicy = () =>
  apiRequestGet<ApiPrivacyPolicyJSON>('v1/instance/privacy_policy');

// A stable version avoids reusing browser-cached configuration from before
// Skyhaven raised its poll and post limits, while retaining normal response caching.
export const apiGetInstance = () =>
  apiRequestGet<ApiInstanceJSON>('v2/instance?skyhaven_polls=10&skyhaven_post_chars=5000');

export const apiGetExtendedDescription = () =>
  apiRequestGet<ApiExtendedDescriptionJSON>('v1/instance/extended_description');

export const apiGetTranslationLanguages = () =>
  apiRequestGet<ApiTranslationLanguagesJSON>(
    'v1/instance/translation_languages',
  );

export const apiGetDomainBlocks = () =>
  apiRequestGet<ApiDomainBlockJSON[]>('v1/instance/domain_blocks');
